import { IonRange } from '@ionic/react';
import React from 'react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { EffectFade } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType } from 'swiper/types';

import { UiTypography } from '@/components/ui/Typography';

import './ImageSwiperRange.scss';

export const ImageSwiperRange: React.FC<{
  pictures: {
    imageSrc: string;
    label: string;
  }[];
  defaultIndex: number;
  onRangeInput: (e: CustomEvent) => void;
  onRangeChange: (e: CustomEvent) => void;
}> = ({
  pictures,
  defaultIndex,
  onRangeInput: onRangeInputProps,
  onRangeChange: onRangeChangeProps,
}) => {
  const swiperRef = React.useRef<SwiperType | null>(null);
  const [rangeIndex, setRangeIndex] = React.useState(defaultIndex);

  React.useEffect(() => {
    setTimeout(() => {
      if (swiperRef.current) {
        swiperRef.current.slideTo(rangeIndex);
        swiperRef.current.update();
      }
    });
    setTimeout(() => {
      if (swiperRef.current) {
        swiperRef.current.slideTo(rangeIndex);
        swiperRef.current.update();
      }
    }, 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onRangeInput = (e: CustomEvent) => {
    const value = e.detail.value || (0 as number);
    setRangeIndex(value);

    if (swiperRef.current) {
      swiperRef.current.slideTo(value);
      swiperRef.current.update();
    }

    onRangeInputProps(e);
  };

  const onRangeChange = (e: CustomEvent) => {
    onRangeChangeProps(e);
  };

  return (
    <div className="image-swiper-range">
      <div className="img-container">
        <Swiper
          initialSlide={defaultIndex}
          defaultValue={defaultIndex}
          effect={'fade'}
          modules={[EffectFade]}
          className="mySwiper"
          draggable={false}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          slideActiveClass="active"
        >
          {pictures.map((item) => (
            <SwiperSlide key={item.label}>
              <img src={item.imageSrc} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <UiTypography
        className="characteristic-label"
        color="black"
        variant="title-large"
      >
        {pictures[rangeIndex].label}
      </UiTypography>
      <IonRange
        className="range"
        onIonInput={onRangeInput}
        onIonChange={onRangeChange}
        aria-label="AI Characteristic"
        ticks={true}
        snaps={true}
        min={0}
        max={pictures.length - 1}
        value={rangeIndex}
      />
    </div>
  );
};
